export enum ORGANIZATION_TYPE_ENUM {
	DISPENSARY = 'dispensary',
	BRAND = 'brand',
}